import React, { useEffect, useState } from 'react';
import Nav from '../LandingPage/Nav/Nav';
import Footer from '../LandingPage/Footer/Footer';
import './Privacypolicy.css';
import { getwebsiteconfigs } from '../../Services/APIrequests'; // Adjust path as needed

function Privacypolicy() {
  const [content, setContent] = useState('');

  const fetchPrivacyPolicy = async () => {
    try {
      const response = await getwebsiteconfigs('Privacy Policy');
      if (response?.data?.Status === 1) {
        const description = response?.data?.webSites?.description || '';
        setContent(description);
      }
    } catch (error) {
      console.error('Error fetching Privacy Policy:', error);
    }
  };

  useEffect(() => {
    fetchPrivacyPolicy();
  }, []);

  return (
    <div>
      <Nav />
      <div className='Privacy_Policy'>
        <h1 className='Privacy_Policy_heading'>Privacy Policy</h1>
        <div
          className="Privacy_Policy_content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
      <Footer />
    </div>
  );
}

export default Privacypolicy;
